import { SharedContent } from './shared-content';

export const InheritedIraDecedentInfoContent = {
  title: "We're about to begin opening your account",
  subtitle:
    'To ensure we open the right account, we need to know if the IRA was previously inherited by the decedent. Meaning, someone passed away leaving it to them. If so, it would be listed as an "Inherited IRA" on all of the account statements.',
  previouslyInheritedQuestion: 'Was the IRA previously inherited?',
  yes: 'Yes',
  no: 'No',
  radioRequiredError: SharedContent.radioRequiredError,
  inputRequiredError: SharedContent.requiredError,
  iraTypeQuestion: 'What type of IRA did the decedent own?',
  previouslyInheritedIraTypeOptions: {
    nonRoth: 'Inherited IRA',
    roth: 'Inherited Roth IRA',
  },
  notPreviouslyInheritedIraTypeOptions: {
    nonRoth: 'Traditional, Simple, or SEP IRA',
    roth: 'Roth IRA',
  },
  originalDecendentName: {
    question: "What was the original decedent's name?",
    label: "Original decedent's full name",
  },
  decedentName: {
    question: "What was the decedent's name?",
    label: "Decedent's full name",
  },
  continueButton: SharedContent.buttons.continueButton,
};
